<template>
  <form class="trbo-a-multiple-input" @submit.prevent="onSubmit">
    <input-item
      v-for="(input, index) in questionData.inputs"
      :key="index"
      v-model="values[index]"
      :input="input"
    />
    <div class="trbo-a-multiple-input__actions">
      <button type="submit" class="trbo-a-multiple-input__button">{{ questionData.inputButtonTitle }}</button>
    </div>
  </form>
</template>

<script>
// @flow

import InputItem from './InputItem.vue'

export default {
  components: {
    InputItem
  },
  props: {
    question: {
      type: Object, // WizardPage
      required: true
    },
    questionData: {
      type: Object, // WizardPageData<InputData>
      required: true
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      values: []
    }
  },
  computed: {
    classes () {
      return {
        'multiple-input__item': true,
        'multiple-input__item--with-icon': !!this.icon
      }
    }
  },
  watch: {
    selected (newValue) {
      this.$nextTick(() => {
        this.values = newValue
      })
    }
  },
  mounted () {
    this.values = this.selected
  },
  methods: {
    onSubmit () {
      const isValid = this.validate()
      if (isValid) {
        const { question, values } = this
        const options = values.map((value) => ({ value }))
        this.$emit('submit', { question, options })
      }
    },
    validate () {
      return this.questionData.inputs.every((_, index) => !!this.values[index])
    }
  }
}
</script>

<style scoped src="./multiple-input.scss" />
